'use strict'
const merchants = {
    name: 'merchants',
    path: 'merchants',
    redirect: { name: 'merchants-view' },
    meta: {
        title: '商户管理-秀川结算中心-综合服务平台',
        name: '商户管理',
        tagsTitle: '商户管理',
        breadcrumb: '商户管理',
        code: ''
    },

    component: () => import('@/components/RouterViewTab'),
    children: [
        {
            name: 'merchants-view',
            path: '',
            redirect: { name: 'merchants-list' },
            meta: {
                title: '商户管理-秀川结算中心-综合服务平台',
                name: '商户列表',
                tagsTitle: '商户列表',
                breadcrumb: '商户列表',
                code: ''
            },
            component: () => import('@/components/RouterView'),
            children:[
                {
                    path: 'list',
                    name: 'merchants-list',
                    meta: {
                        title: '商户列表-商户管理-秀川结算中心-综合服务平台',
                        name: '',
                        tagsTitle: '商户列表',
                        code: ''
                    },
                    component: () => import('@/pages/merchants/Merchants'),
                },
            ]
        },
        {
            path: 'detail/:id',
            name: 'merchant-detail',
            meta: {
                title: '商户详情-商户管理-秀川结算中心-综合服务平台',
                name: '商户详情',
                tagsTitle: '商户详情',
                code: ''
            },
            redirect: {name:'merchants-detail-info'},
            component: () => import('@/components/RouterView'),
            children: [
                {
                    path: 'info',
                    name: 'merchants-detail-info',
                    meta: {
                        title: '商户详情-商户管理-秀川结算中心-综合服务平台',
                        name: '签约信息',
                        tagsTitle: '签约信息',
                        tabIndex: 0,
                        code: ''
                    },
                    component: () => import('@/pages/merchants/DetailInfoCopy'),
                },
                {
                    path: 'risk-control-info',
                    name: 'risk-control-info',
                    meta: {
                        title: '商户详情-商户管理-秀川结算中心-综合服务平台',
                        name: '风控资料',
                        tabIndex: 7,
                        tagsTitle: '风控资料',
                        code: ''
                    },
                    component: () => import('@/pages/merchants/RiskControlInfo'),
                },
                {
                    path: 'signing-people',
                    meta: {
                        title: '商户详情-商户管理-秀川结算中心-综合服务平台',
                        name: '',
                        tagsTitle: '签约个体',
                        tabIndex: 4,
                        code: 'individuals.index'
                    },
                    name: 'merchants-detail-individual',
                    component: () => import('@/pages/merchants/SignPeople'),
                },
                {
                    path: 'pay-detail',
                    meta: {
                        title: '商户详情-商户管理-秀川结算中心-综合服务平台',
                        name: '打款明细',
                        tagsTitle: '打款明细',
                        tabIndex: 6,
                        code: 'pay-details.index'
                    },
                    name: 'merchants-pay-detail',
                    component: () => import('@/pages/merchants/PayDeatils'),
                },
            ]
        }
    ]
};

export default merchants;
